import type { NormalisedPermissionAssignment as ClientResponse } from "@onhandtech/onhand-fe-shared/lib/api/common/permission-assignments/permission-assignments.types";
import { handleSuccess } from "@onhandtech/onhand-fe-shared/lib/api/common/permission-assignments/services/handle-success";
import type {
	PermissionAssignment,
	PostPermissionAssignmentPayload,
} from "@onhandtech/onhand-fe-shared/lib/contracts/api/common/permission-assignments";
import { createReduxServiceModule } from "@onhandtech/onhand-fe-shared/lib/redux";
import type { RequestArgs } from "@onhandtech/onhand-fe-shared/lib/request";
import {
	createRequestError,
	formatEndpoint,
} from "@onhandtech/onhand-fe-shared/lib/request";
import type { AxiosError } from "axios";

import { getConfig } from "../../../../../../config/configuration";

export const moduleName = "post-campaign-permissions";

const args: RequestArgs<
	PermissionAssignment,
	ClientResponse,
	never,
	PostPermissionAssignmentPayload<"campaign_id">
> = {
	method: "POST",
	url: formatEndpoint(getConfig().endpoints.api.v5.campaignSetPermissions),
	handleSuccess,
	handleFailure: (error: AxiosError) => createRequestError(error, moduleName),
};

const postCampaignPermissionAssignmentsModule = () =>
	createReduxServiceModule<
		PermissionAssignment,
		ClientResponse,
		never,
		PostPermissionAssignmentPayload<"campaign_id">
	>({ moduleName, args });

export default postCampaignPermissionAssignmentsModule;
